/**
 * Defaults
 *
 * Overwrites if obj value is one of [''|null|undefined|0]
 *
 * @todo fix casted type from "any" to correct type
 * @param {object} object The destination object.
 * @param {...object} sources The source objects.
 * @returns {object} Returns `object`.
 * @example
 *   defaults({a:1, b:'', c:null}, {a:2, b:3, c:4})
 *   // => {a:1, b:3, c:4}
 * @returns {object}
 */

export function getHrefFromResource(resource, link: string) {
  return resource && typeof resource.hasLink === 'function' && resource.hasLink(link)
    ? resource.links(link).href
    : null;
}
